(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats.main')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main', {
        url: '/',
        params: {              
          tipus: 0,
          nom: '',
          errorproces: undefined,
          submenuInfo: {
            visible: true,
            left: {
              visible: true,
              visibleMenu: true,
              collapsable: true,
              collapsed: false,
              name: 'DEFAULT_ENTITATS',
              nameCollapsed: 'DEFAULT_ENTITATS',
              icon: 'view_list',
              columns: 4,
              columnsCollapsed: 0
            },
            content: {
              visible: true,
              collapsable: true,
              collapsed: true,
              columnsCollapsed: 0,
              menu: {
                minColumns: 3,
                minOptions: 2
              },
              dynamicMenu: {
                minColumns: 3,
                minOptions: 2
              }
            },
            right: {
              visible: false,
              visibleMenu: false,
            }
          }
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(entitatsHeaderSubmenuLinksValue) {
                return entitatsHeaderSubmenuLinksValue;
              }
            }
          },
          'leftSide': {
            templateUrl: 'entitats/main/llista/llista.tpl.html',
            controller: 'EntitatsMainLlistaCtrl',
            controllerAs: 'ctrl'
          }
        }
      })
      .state('entitats.main.submain', {
        url: '{idEntitat:[0-9]{0,32}}',
        abstract: true,
        views: {
          'content@entitats': {
            templateUrl: 'shared/submain/submain.tpl.html'
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'entitats.main.submain.dades',
          textParam: {paramName: 'label', paramValue: '{{entitatData.data.nom}}'}
        },
        resolve: {
          entitatData: function(EntitatFactory, $stateParams) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idEntitat)
                      && $stateParams.idEntitat !== null
                      && $stateParams.idEntitat) {
              return EntitatFactory.get($stateParams.idEntitat).catch(function(){});
            }
            else {
              return {};
            }
          },
          breadcrumbText: function($stateParams){
            if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }
        }
      });
  }
}());
